import type { MouseEvent } from 'react';

import ChevronIcon from '~/assets/icons/Chevron';
import CloseIcon from '~/assets/icons/Close';
import SoleIcon from '~/assets/icons/Sole';
import type { MenuHeaderProps } from '~/legacy/types';
import { logoIcons } from '~/legacy/utils';

const MenuHeader = ({
  name,
  headerBack,
  onClose,
  selectedItem,
  showBackButton
}: MenuHeaderProps) => {
  const goBack = () => {
    headerBack && selectedItem && headerBack(selectedItem);
  };

  const closeMenu = (event: MouseEvent) => {
    event.stopPropagation();
    onClose();
  };

  const isMainMenu = !name;

  return (
    <div className="menu-header" onClick={goBack}>
      <div className="menu-header__controls">
        {!showBackButton && (
          <button
            type="button"
            aria-label="Close menu"
            onClick={closeMenu}
            className="menu-header__close"
          >
            <CloseIcon width="12" height="12" stroke="black" />
          </button>
        )}
        {showBackButton && (
          <span className="menu-header__angle-left inline-block rotate-90">
            <ChevronIcon width="14" height="14" stroke="#333333" />
          </span>
        )}
      </div>
      <div className="menu-header__content">
        {isMainMenu ? (
          <div className="menu-header__icon">
            <SoleIcon width="50" height="50" colour="#000000" />
          </div>
        ) : (
          <>
            {selectedItem!.type === 'brand' ? (
              <div className="menu-header__icon">
                <img
                  loading="lazy"
                  alt={selectedItem!.name}
                  src={logoIcons[selectedItem!.icon]}
                />
              </div>
            ) : (
              selectedItem!.displayName || selectedItem!.name
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MenuHeader;
